export enum Visibility {
	PUBLIC = "PUBLIC",
	PRIVATE = "PRIVATE",
	RESTRICTED = "RESTRICTED",
}

export enum VisibilityGlossaries {
	PUBLIC = "PUBLIC",
	PRIVATE = "PRIVATE",
}

export const ACCESS_RIGHT_MAP: any = {
	PUBLIC: 1,
	PRIVATE: 2,
	RESTRICTED: 3,
};
